export interface MasterSnak {
  name: string
  hookQuestion: string
  strategicPurpose: string
}

export const masterSnaks: MasterSnak[] = [
  {
    name: '1. Everyday Infection Challenge',
    hookQuestion:
      '“Which infection scenario do you see most often in daily practice?”',
    strategicPurpose:
      'Start with recognition. Make the campaign feel relevant to the HCP’s real clinical routine.',
  },
  {
    name: '2. The Trusted Choice Reset',
    hookQuestion:
      '“When choosing an antibiotic, how much does experience matter?”',
    strategicPurpose:
      'Reframe an established brand’s legacy status as strength, not oldness.',
  },
  {
    name: '3. Right Patient, Right Moment',
    hookQuestion:
      '“What gives you confidence that this is the right treatment moment?”',
    strategicPurpose:
      'Connect the brand to clinical judgment and appropriate use.',
  },
  {
    name: '4. Stewardship Balance',
    hookQuestion:
      '“What is harder today: treating effectively or prescribing responsibly?”',
    strategicPurpose:
      'Address the modern antibiotic tension without sounding defensive.',
  },
  {
    name: '5. Follow-Up Confidence',
    hookQuestion: '“After the prescription, what matters most?”',
    strategicPurpose:
      'Extend the story beyond the initial prescription into patient management and practical confidence.',
  },
]
